import React from 'react';
import { Link } from 'react-router-dom';
interface CategoryCardProps {
  title: string;
  image: string;
  count: number;
  link: string;
}
export function CategoryCard({
  title,
  image,
  count,
  link
}: CategoryCardProps) {
  return <Link to={link} className="block group" data-id="element-13">
      <div className="relative rounded-lg overflow-hidden" data-id="element-14">
        {/* Category Image with Overlay */}
        <div className="aspect-[4/3] w-full" data-id="element-15">
          <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-16" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-17"></div>
        </div>
        {/* Category Info */}
        <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-18">
          <h3 className="text-xl font-semibold mb-1" data-id="element-19">{title}</h3>
          <p className="text-sm opacity-90" data-id="element-20">{count} products</p>
        </div>
      </div>
    </Link>;
}